<template>
  <div class="card card-profile">
    <img src="../../assets/img/nexon-santa.png" alt="Image placeholder" class="card-img-top" />
    <div class="row justify-content-center">
      <div class="col-4 col-lg-4 order-lg-2">
        <div class="mt-n4 mt-lg-n6 mb-4 mb-lg-0">
          <a href="javascript:;">
            <img src="../../assets/img/robot.png" class="rounded-circle img-fluid border border-2 border-white" />
          </a>
        </div>
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="text-center mt-4">
        <h5>
          {{ userInfo.name }} {{ userInfo.last_name }}
        </h5>
        <div class="h6 font-weight-300">
          <i class="ni location_pin mr-2"></i>
          {{ userInfo.role_title }}
        </div>
        <div class="h6 mt-4">
          <i class="ni business_briefcase-24 mr-2"></i>
          {{ userInfo.team }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const userInfo = ref({});

// Función para obtener los datos del usuario
const fetchUserInfo = async () => {
  try {
    const response = await axios.post(`${API_BASE_URL}/user-info`, {}, {
      headers: {
        Authorization: `Bearer ${token}`, // Agrega el token en el header
      },
    });
    userInfo.value = response.data[0];
  } catch (error) {
    console.error('Error al obtener los datos del usuario:', error);
  }
};

onMounted(() => {
  fetchUserInfo();
});

</script>
